import { render, staticRenderFns } from "./department_edit.vue?vue&type=template&id=ad0193b0&scoped=true&"
import script from "./department_edit.vue?vue&type=script&lang=js&"
export * from "./department_edit.vue?vue&type=script&lang=js&"
import style0 from "./department_edit.vue?vue&type=style&index=0&id=ad0193b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0193b0",
  null
  
)

export default component.exports